import type { App } from "vue";
import * as Utilities from "@app/Components/Utilities";
import { JupiterButton } from "@modules/Jupiter";
import ConciergeButton from "@app/Components/Buttons/ConciergeButton.vue";
import RoadsideAssistanceButton from "@app/Components/Buttons/RoadsideAssistanceButton.vue";

const GlobalComponents: Record<string, any> = {
    'Spacer': Utilities.Spacer,
    'ContentSpacer': Utilities.ContentSpacer,
    'BackButton': Utilities.BackButton,
    'PhoneNumber': Utilities.PhoneNumber,
    'JupiterButton': JupiterButton,
    'ConciergeButton': ConciergeButton,
    'RoadsideAssistanceButton': RoadsideAssistanceButton
};

export function useGlobalComponents()
{
    return {
        install: ( app: App ) =>
        {
            for( const key in GlobalComponents )
            {
                app.component( key, GlobalComponents[ key ] );
            }
        }
    };
};